import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ChatOption } from '../../models/chat.models';
import { ChatService } from '../../services/chat.service';

@Component({
    selector: 'app-chat-options-menu',
    templateUrl: './chat-options-menu.component.html',
    styleUrls: ['./chat-options-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatOptionsMenuComponent {
    @Input() options: ChatOption[] = [];
    @Input() isMobileApp: boolean = false;

    @Output() selected = new EventEmitter<ChatOption>();

    constructor(private readonly chatService: ChatService) {
    }

    selectOption(option: ChatOption): void {
        this.selected.emit(option);
    }

    getDisplayContent(option: ChatOption) {
        return this.chatService.getDisplayContent(option, true);
    }
}